import { createContext, useContext, type ReactNode } from "react";

import type { RuntimeConfig } from "./schema";

const RuntimeConfigContext = createContext<RuntimeConfig | null>(null);

export function RuntimeConfigProvider({
  config,
  children,
}: {
  config: RuntimeConfig;
  children: ReactNode;
}) {
  return (
    <RuntimeConfigContext.Provider value={config}>
      {children}
    </RuntimeConfigContext.Provider>
  );
}

/**
 * Runtime configuration is guaranteed present inside the application tree: the
 * boot sequence renders a fail-closed screen instead of children when it is
 * missing, so a null here is a programming error rather than a runtime state.
 */
export function useRuntimeConfig(): RuntimeConfig {
  const config = useContext(RuntimeConfigContext);
  if (!config) {
    throw new Error(
      "useRuntimeConfig was called outside RuntimeConfigProvider. The " +
        "application shell must not render before configuration is loaded.",
    );
  }
  return config;
}
